import { MEDICATION_SECTION } from "../../utils/subjective-entry";
import { checkNull, ReportContainer } from "../constant";
import EntryLines from "./EntryLines";

interface MedicationsBlockProps {
  data: any;
}

const MedicationsBlock = ({ data }: MedicationsBlockProps) => {
  if (!checkNull(data?.patientMedications)) return null;

  return (
    <ReportContainer label="Medications">
      <EntryLines
        section={MEDICATION_SECTION}
        rows={data?.patientMedications}
      />
    </ReportContainer>
  );
};

export default MedicationsBlock;
